<div *ngIf="isLoading | async" class="overlay">
  <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" [value]="value">
  </mat-progress-spinner>
</div>
